export const scrollChatToBottom = () => {
    setTimeout(()=>{
        const el = document.querySelector('.message-container .conversation > div:last-child') as HTMLElement;
        document.querySelector('.message-container .conversation').scrollTop = (el?.offsetTop ? el.offsetTop : 1000) * 10;
    }, 100);
};